export var SoupType;
(function (SoupType) {
    SoupType["Soup"] = "soup";
    SoupType["Tag"] = "tag";
    SoupType["Text"] = "text";
    SoupType["Comment"] = "comment";
    SoupType["Directive"] = "directive";
})(SoupType || (SoupType = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/beautiful-soup-js/build/es/main/Type.js
// module id = null
// module chunks = 